
<div class="cx">

  <p class="cx-summary">{{ totalConnections }} {{ totalConnections === 1 ? 'connection' : 'connections' }} to this record</p>

  <!-- shared avatar -->
  <ng-template #cxAvatar let-c let-tone="tone">
    <span class="cx-avatar" [ngClass]="'is-' + (tone || avatarTone(c.name))">
      <img *ngIf="c.imageUrl" src="{{c.imageUrl}}" alt="">
      <ng-container *ngIf="!c.imageUrl">{{ c.shortName }}</ng-container>
    </span>
  </ng-template>

  <!-- shared email / phone line -->
  <ng-template #cxContact let-c>
    <span class="cx-item__contact" *ngIf="c.email || c.phone">
      <span *ngIf="c.email" class="cx-item__meta"><mat-icon>mail_outline</mat-icon>{{ c.email }}</span>
      <span *ngIf="c.phone" class="cx-item__meta"><mat-icon>call</mat-icon>{{ formatPhone(c.phone) }}</span>
    </span>
  </ng-template>

  <section class="cx-section" [class.is-collapsed]="collapsedSections.owner">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>person</mat-icon></span>
      <h3>Owner</h3>
      <span class="cx-count">{{ Owners.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" *ngIf="Owners.length == 0" (click)="addOwner(ownerAdd,false,false,'')"
        matTooltip="Add owner" matTooltipClass="tooltip" attr.aria-label="Add owner">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('owner')"
        [attr.aria-expanded]="!collapsedSections.owner" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.owner ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.owner">
      <div class="cx-item" *ngFor="let c of Owners">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'owner' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role">Record owner</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="ownerMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #ownerMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)"><mat-icon>person_remove</mat-icon> Remove owner</button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="Owners.length == 0">No owner yet.</p>
    </div>
  </section>

  <section class="cx-section" [class.is-collapsed]="collapsedSections.contacts">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>contacts</mat-icon></span>
      <h3>{{ ContactName }}</h3>
      <span class="cx-count">{{ NormalContacts.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addShare(shareAdd,false,false,'')"
        matTooltip="Add {{ ContactName }}" matTooltipClass="tooltip" attr.aria-label="Add {{ ContactName }}">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('contacts')"
        [attr.aria-expanded]="!collapsedSections.contacts" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.contacts ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.contacts">
      <div class="cx-item" *ngFor="let c of NormalContacts">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'violet' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role" *ngIf="c.contactCompanyRoleMappingModels?.length">{{ relationText(c.contactCompanyRoleMappingModels) }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <span class="cx-dot" [class.is-on]="c.isPortalAccess"
            [matTooltip]="c.isPortalAccess ? 'Has portal access' : 'No portal access'" matTooltipClass="tooltip"></span>
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="contactMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #contactMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item (click)="togglePortalAccess(c)">
            <mat-icon>{{ c.isPortalAccess ? 'lock' : 'lock_open' }}</mat-icon>
            {{ c.isPortalAccess ? 'Revoke portal access' : 'Give portal access' }}
          </button>
          <button mat-menu-item (click)="addShare(RoleAddEdit,false,true,c)"><mat-icon>label</mat-icon> Add relation</button>
          <button mat-menu-item *ngFor="let transRole of c.contactCompanyRoleMappingModels"
            (click)="deleteRole(transRole.contactCompanyRoleID,$event)">
            <mat-icon>label_off</mat-icon> Remove "{{ transRole.rloeName }}"
          </button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)"><mat-icon>person_remove</mat-icon> Remove</button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="NormalContacts.length == 0">No {{ ContactName }} added yet.</p>
    </div>
  </section>

  <section class="cx-section" [class.is-collapsed]="collapsedSections.shared">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>vpn_key</mat-icon></span>
      <h3>Shared access</h3>
      <span class="cx-count">{{ SharedContacts.length + SharedRoleList.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--add" (click)="addShare(shareAdd,true,false,'')"
        matTooltip="Share access" matTooltipClass="tooltip" attr.aria-label="Share access">
        <mat-icon>add</mat-icon>
      </button>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('shared')"
        [attr.aria-expanded]="!collapsedSections.shared" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.shared ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.shared">
      <div class="cx-item" *ngFor="let c of SharedContacts">
        <button type="button" class="cx-item__main" (click)="contactDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'green' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role" *ngIf="c.contactCompanyRoleMappingModels?.length">{{ relationText(c.contactCompanyRoleMappingModels) }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="sharedMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="contactDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #sharedMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="contactDetail(c)"><mat-icon>open_in_new</mat-icon> Open details</button>
          <button mat-menu-item (click)="addShare(RoleAddEdit,true,true,c)"><mat-icon>label</mat-icon> Add relation</button>
          <button mat-menu-item *ngFor="let transRole of c.contactCompanyRoleMappingModels"
            (click)="deleteRole(transRole.contactCompanyRoleID,$event)">
            <mat-icon>label_off</mat-icon> Remove "{{ transRole.rloeName }}"
          </button>
          <button mat-menu-item class="cx-danger" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)"><mat-icon>person_remove</mat-icon> Remove access</button>
        </mat-menu>
      </div>
      <!-- roles with access -->
      <div class="cx-item is-static" *ngFor="let c of SharedRoleList">
        <div class="cx-item__main">
          <span class="cx-avatar is-role"><mat-icon>groups</mat-icon></span>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <span class="cx-item__role">Role</span>
          </span>
        </div>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)"
            matTooltip="Remove access" matTooltipClass="tooltip" aria-label="Remove access">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>
      <p class="cx-empty" *ngIf="SharedContacts.length == 0 && SharedRoleList.length == 0">Not shared with anyone yet.</p>
    </div>
  </section>

  <section class="cx-section" [class.is-collapsed]="collapsedSections.core">
    <div class="cx-section__head">
      <span class="cx-section__icon"><mat-icon>people</mat-icon></span>
      <h3>Associated {{ CoreName }}</h3>
      <span class="cx-count">{{ NormalCore.length }}</span>
      <button type="button" class="cx-icon-btn cx-icon-btn--toggle" (click)="toggleSection('core')"
        [attr.aria-expanded]="!collapsedSections.core" aria-label="Toggle section">
        <mat-icon>{{ collapsedSections.core ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
    </div>

    <div class="cx-section__body" *ngIf="!collapsedSections.core">
      <div class="cx-item" *ngFor="let c of NormalCore">
        <button type="button" class="cx-item__main" (click)="coreDetail(c)">
          <ng-container *ngTemplateOutlet="cxAvatar; context: { $implicit: c, tone: 'blue' }"></ng-container>
          <span class="cx-item__text">
            <span class="cx-item__name">{{ c.name }}</span>
            <ng-container *ngTemplateOutlet="cxContact; context: { $implicit: c }"></ng-container>
          </span>
        </button>
        <span class="cx-item__aside">
          <button type="button" class="cx-icon-btn cx-item__menu" [matMenuTriggerFor]="coreMenu" aria-label="Options">
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-icon class="cx-item__chev" aria-hidden="true" (click)="coreDetail(c)">chevron_right</mat-icon>
        </span>
        <mat-menu #coreMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="coreDetail(c)"><mat-icon>open_in_new</mat-icon> Open record</button>
        </mat-menu>
      </div>
      <p class="cx-empty" *ngIf="NormalCore.length == 0">No {{ CoreName }} linked yet.</p>
    </div>
  </section>

</div>

<ng-template #shareAdd>

    <h2 mat-dialog-title *ngIf="isShare">
       <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add {{ContactName}} / User / Role
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>

        <h2 mat-dialog-title *ngIf="!isShare">
            <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
             Add {{ContactName}}
               <button mat-icon-button (click)="close()">
                 <mat-icon>close</mat-icon>
               </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">   
    <div class="radOpts" *ngIf="isShare">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{ContactName}}</mat-radio-button>
        <mat-radio-button value="3" (click)="selectSharedAccessRb(3)">User</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist *ngIf="!isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="contactsList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="sharedAccessRoleList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>
    
    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
            <div class="detail">
                <h4> {{role.name}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItemRoleSharedAccess(role,isSharedAccessRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCompanyContact()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #ownerAdd>

  <h2 mat-dialog-title>
     <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add Owner 
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
   </h2>     
  
<mat-dialog-content class="mat-typography">  
 
  <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>

  <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
    <li *ngFor="let user of userSelectedList">
      <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
                {{user.shortName}}
              </span>
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
          </div>
          <div class="opt">
              <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
          </div>
      </div>
    </li>
  </ul>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCompanyContact()">Done</button>
</mat-dialog-actions>
</ng-template>

  <ng-template #RoleAddEdit>
    <h2 mat-dialog-title>
       <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Add Relation to {{currentRoleContact.name}}
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">    

    <app-contactlist [objectList]="transRoleList" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelected($event)"  (NotifyListfetch)="getTransactinalRoles($event)"></app-contactlist>
    
    <ul class="selectedlist">      
      <li *ngFor="let role of Roles">
        <div class="userndetail">            
            <div class="detail">
                <h4> {{role.transactionalRoleName}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItem(role,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showContactRoleAddButton (click)="addUpdateCompanyContactRole()">Done</button>
  </mat-dialog-actions>
  </ng-template>


 

  <app-addnew *ngIf="showAddContact" (closeAdd)="getClose($event)" [name]="searchName" (contactSaved)="getNormalAndSharedContacts()" [coreID]="companyID" 
  [isShared]="isShare" [mainModuleName]='mainModuleNameSenForAdd' [modulename]='Module' [ngClass]="{'open': showAddContact}" ></app-addnew>

  <app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='TransactionId' [modulenames]='Module' 
  (closeDetail)="getCloseDetails($event)"></app-details>
